import { useTranslation } from 'react-i18next';

interface DetailRowProps {
  label: string;
  value: string;
  isPhone?: boolean;
  isEmail?: boolean;
  isLink?: boolean;
}

function DetailRow({ label, value, isPhone, isEmail, isLink }: DetailRowProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4 py-3 border-b border-gray-200 last:border-b-0">
      <dt className="text-sm font-semibold text-slate-primary sm:w-64 shrink-0">
        {label}
      </dt>
      <dd className="text-sm text-gray-700">
        {isPhone ? (
          <a href={`tel:+1${value.replace(/-/g, '')}`} aria-label="Appeler Couvreur-Lévis.com au 418-476-9950" title="Cliquez pour appeler" className="text-copper hover:underline">{value}</a>
        ) : isEmail ? (
          <a href={`mailto:${value}`} className="text-copper hover:underline">{value}</a>
        ) : isLink ? (
          <a href={value} rel="nofollow noopener noreferrer" target="_blank" className="text-copper hover:underline">{value}</a>
        ) : (
          value
        )}
      </dd>
    </div>
  );
}

export default function ContentMentions() {
  const { t } = useTranslation('mentionslegales');

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="space-y-12">
          {/* Éditeur */}
          <div>
            <h2 className="text-xl md:text-2xl font-manrope font-bold text-slate-primary mb-6">
              {t('editeur_h2')}
            </h2>
            <dl className="bg-soft-gray rounded-lg p-5 md:p-6">
              <DetailRow label={t('editeur_raison')} value={t('editeur_raison_val')} />
              <DetailRow label={t('editeur_statut')} value={t('editeur_statut_val')} />
              <DetailRow label={t('editeur_adresse')} value={t('editeur_adresse_val')} />
              <DetailRow label={t('editeur_tel')} value={t('editeur_tel_val')} isPhone />
              <DetailRow label={t('editeur_email')} value={t('editeur_email_val')} isEmail />
              <DetailRow label={t('editeur_neq')} value={t('editeur_neq_val')} />
            </dl>
          </div>

          {/* Hébergement */}
          <div>
            <h2 className="text-xl md:text-2xl font-manrope font-bold text-slate-primary mb-6">
              {t('hebergement_h2')}
            </h2>
            <dl className="bg-soft-gray rounded-lg p-5 md:p-6">
              <DetailRow label={t('hebergement_nom')} value={t('hebergement_nom_val')} />
              <DetailRow label={t('hebergement_adresse')} value={t('hebergement_adresse_val')} />
              <DetailRow label={t('hebergement_site')} value={t('hebergement_site_val')} isLink />
            </dl>
          </div>

          {/* Propriété intellectuelle */}
          <div>
            <h2 className="text-xl md:text-2xl font-manrope font-bold text-slate-primary mb-4">
              {t('pi_h2')}
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              {t('pi_text')}
            </p>
          </div>

          {/* Responsabilité */}
          <div>
            <h2 className="text-xl md:text-2xl font-manrope font-bold text-slate-primary mb-4">
              {t('responsabilite_h2')}
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              {t('responsabilite_text')}
            </p>
          </div>

          {/* Liens externes */}
          <div>
            <h2 className="text-xl md:text-2xl font-manrope font-bold text-slate-primary mb-4">
              {t('liens_h2')}
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              {t('liens_text')}
            </p>
          </div>

          {/* Droit applicable */}
          <div>
            <h2 className="text-xl md:text-2xl font-manrope font-bold text-slate-primary mb-4">
              {t('droit_h2')}
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              {t('droit_text')}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h2 className="text-xl md:text-2xl font-manrope font-bold text-slate-primary mb-4">
              {t('contact_h2')}
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              Contactez-nous à{' '}
              <a href="mailto:contact@couvreur-levis.com" className="text-copper hover:underline">contact@couvreur-levis.com</a>
              {' '}ou au{' '}
              <a href="tel:+14184769950" aria-label="Appeler Couvreur-Lévis.com au 418-476-9950" title="Cliquez pour appeler" className="text-copper hover:underline">418-476-9950</a>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}